import React from "react";
import Radio from "./Radio";

function RadioButton({
  className = "",
  title,
  isChecked,
  onChange,
  value,
  testid,
}) {
  return (
    <label
      className={`bg-white py-3 px-4 w-fit rounded-lg ${className} ${
        isChecked ? "bg-[#5F5FFA14] border border-pri " : "border-light"
      }`}
    >
      <div className="flex gap-2 items-center">
        <Radio {...{ isChecked, value, onChange, testid }} />
        <p className="mb-0 text-dark p-xs font-medium">{title}</p>
      </div>
    </label>
  );
}

export default RadioButton;
